import { create } from "zustand";
import type { OrgRole } from "@/lib/permissions";

interface AuthState {
  uid: string | null;
  email: string | null;
  displayName: string | null;
  orgId: string | null;
  role: OrgRole | null;
  isPlatformAdmin: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;

  setUser: (user: {
    uid: string;
    email: string | null;
    displayName: string | null;
    orgId: string;
    role: OrgRole;
    isPlatformAdmin: boolean;
  }) => void;
  clearUser: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  uid: null,
  email: null,
  displayName: null,
  orgId: null,
  role: null,
  isPlatformAdmin: false,
  isAuthenticated: false,
  isLoading: true,

  setUser: (user) =>
    set({
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      orgId: user.orgId,
      role: user.role,
      isPlatformAdmin: user.isPlatformAdmin,
      isAuthenticated: true,
      isLoading: false,
    }),

  clearUser: () =>
    set({
      uid: null,
      email: null,
      displayName: null,
      orgId: null,
      role: null,
      isPlatformAdmin: false,
      isAuthenticated: false,
      isLoading: false,
    }),

  setLoading: (loading) => set({ isLoading: loading }),
}));
